import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/cutSlice";

const CutMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    // State for confirmation modal
    const [itemToDelete, setItemToDelete] = useState("")

    // Fetch cut data
    const {
        data: cutData = [],
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.cut.getcut,
        queryKey: "fetchCutMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    },[])
    const sortedCutData = [...cutData].sort((a, b) => a.CUTID - b.CUTID);


    const onSuccessDelete = (data) => {
        setItemToDelete("");
        funLoadData()
    };

    // Delete cut mutation
    const { mutate: deletecut } = usePost({
        url: apiRoute.cut.deleteCut,
        queryKey: "deleteCutMaster",
        onSuccessTasks: onSuccessDelete,
        successMessage:"Cut Deleted"

    });

    // Open confirmation box
    const handleDeleteClick = (CUTID) => {
        setItemToDelete(CUTID);
    };

    const handleConfirmBox = (confirm) => {
        if (confirm && itemToDelete) {
            deletecut({ data: { CUTID: itemToDelete } });
        }
        else
        setItemToDelete("");
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.diamondParamater.cut.createCutMaster);
    };

const exportColumns=[
    {uid:"CutId",name:"CutID"}, {uid:"Cut_Name",name:"Cut Name"}, {uid:"Cut_Group",name:"Cut Group"},{uid:"Cut_Ord",name:"Cut Ord"}
]
const downloadDataFooter={
    CutId:"", Cut_Name:"", Cut_Group:"", Cut_Ord:""
}


    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "CUTID", uid: "CutId", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "CUT NAME", uid: "Cut_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "cut group", uid: "Cut_Group", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "cut ord", uid: "Cut_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                console.log(row)
                let obj = {
                    CUTID: row.CutId
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.cut.createCutMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                handleDeleteClick(row.CutId);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isError) return <ErrorCard />;
    if (isPending) return <LoadingCard />;

    return (
        <div>
            <MainContainer pageName="Cut" breadcrumbs={["Diamond Parameter", "Cut Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "CutId", "Cut_Name", "Cut_Group", "Cut_Ord"]}
                    data={sortedCutData}
                    columns={columns}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    rowActionBtn={rowActionBtn}
                    downloadFileName="Cut-master-List"
                    showAdvanceFilter={false}
                    id="CuTId"

                />
            </MainContainer>

            {itemToDelete && itemToDelete!="" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default CutMaster;
